import { z } from 'my-zod'
import { DamageWaiverCasePrimaryLeadTypeEnum } from './damage-waiver-case-enums'

export const advancedReviewInfoFragment = z.object({
  shortId: z.string(),
  primaryLead: DamageWaiverCasePrimaryLeadTypeEnum,
  corVelClaimNumber: z.string().max(50).setLabel('CorVel Claim Number'),
  pssReleased: z.boolean().setLabel('PSS Released'),
  legalReleased: z.boolean()
})
